module.exports = __webpack_public_path__ + "static/media/Homevideo.b576c465.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Homevideo.mp4
// module id = 87
// module chunks = 0